<template>
  <ComContainer>
    <div class="com-content">
      <!-- <ComBinaryButton
        v-if="isPersonal"
        v-model="status"
        :option="statusList"
        :style="{ marginTop: '20px', marginBottom: '16px', fontSize: '20px' }"
      ></ComBinaryButton> -->
      <PostInfo v-if="status === 0" :postInfo="postInfo"/>
      <DeclareGuide v-if="status === 1" :data="postInfo.guideContent"/>
      <CheckInfo v-if="!isPersonal" :checkInfo="postInfo.reviewOpinionVoList"/>
      <ApplyBtn v-if="isPersonal" :data="postInfo"/>
    </div>
  </ComContainer>
</template>

<script>
import ComContainer from '@/components/common/com-container.vue'
// import ComBinaryButton from '@/components/common/buttons/com-binary-button.vue'
import PostInfo from './post-info'
import DeclareGuide from './declare-guide'
import ApplyBtn from './apply-btn'
import CheckInfo from './check-info'

import { postDeclarationHallPostInfo } from '@/api/personal/daclare'

export default {
  name:'DeclarePost',
  components: {
    ComContainer,
    // ComBinaryButton,
    PostInfo,
    DeclareGuide,
    ApplyBtn,
    CheckInfo
  },
  data () {
    return {
      status: 0, //未审核 已审核,
      statusList: [
        { label: '岗位基本信息', value: 0 },
        { label: '申报指南', value: 1 }
      ],
      postInfo: {}
    }
  },
  computed: {
    isPersonal () {
      return this.$route.path.includes('personal')
    }
  },
  methods: {
    getData () {
      postDeclarationHallPostInfo({
        postId: this.$route.query.postId,
        planId: this.$route.query.planId
      }).then(res => {
        console.log(res, 'postDeclarationHallPostInfo');
        if (res.code == 0) {
          this.postInfo = res.data;
        }
      })
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
.com-content {
  background-color: #fff;
  padding: 20px 0;
}
</style>
